import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'reflect-metadata';
import {
  BrowserRouter,
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import theme from './theme';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import LanguageProvider from './LanguageProvider';
import ResponsiveListener from './utils/responsiveListener';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: '*',
    element: <App />,
  },
]);

root.render(
  <React.StrictMode>
    <ResponsiveListener />
    <I18nextProvider i18n={i18n}>
      <LanguageProvider>
        <ChakraProvider theme={theme}>
          <RouterProvider router={router} />
        </ChakraProvider>
      </LanguageProvider>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
